import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, Chip, SxProps, Theme } from '@mui/material';

import { ProfileChipProps } from './types';

export const ProfileChip = ({
  option,
  onDelete,
  groupKey,
  fieldName,
  index,
  variant,
}: ProfileChipProps) => {
  const handleDelete = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();
    onDelete?.();
  };

  return (
    <Chip
      variant={variant}
      label={option.label?.length > 20 ? `${option.label?.slice(0, 10)}...` : option.label}
      type="trailing"
      size="md"
      sx={chipSx}
      deleteIcon={
        <Box sx={deleteIconContainerStyle}>
          <AppIcon iconName="XClose" diameter="12px" color="Gray/400" />
        </Box>
      }
      key={`${groupKey}-${fieldName}-${option.value}-${index}`}
      onDelete={handleDelete}
    />
  );
};

const chipSx: SxProps<Theme> = ({ backrs }) => ({
  border: `1.5px solid ${backrs.colors['Colors/Border/border-primary']}`,
});

const deleteIconContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  cursor: 'pointer',
  margin: `${backrs.spacing['spacing-none']} !important`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
